<nz-divider></nz-divider>
<form nz-form *ngIf="load" [nzLayout]="'vertical'" [formGroup]="RISKASSApprovalForm">
  <div nz-row [nzGutter]="{ xs: 8, sm: 8, md: 8, lg: 24, xl: 48, xxl: 48 }">
    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item>
        <nz-form-label nzFor="approvalStatus" nzRequired>Approval Status
          <span nz-tooltip nzTitle="Approval Status">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>
        <nz-form-control [nzErrorTip]="'Approval Status is Required'">
          <nz-select required [nzPlaceHolder]="'Approval Status'" id="approvalStatus" formControlName="approvalStatus" (ngModelChange)="approvalStatusChange($event)"
            id="approvalStatus" [nzShowSearch]="true">
            <nz-option *ngFor="let i of approvalStatusList" [nzLabel]="i.label" [nzValue]="i.label"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24" *ngIf="actionApprove">
      <nz-form-item>
        <nz-form-label nzFor="Recommended Outcome" nzRequired>Recommended Outcome
          <span nz-tooltip nzTitle="Recommended Outcome">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>
        <nz-form-control [nzErrorTip]="'Recommended Outcome Required'">
          <nz-select required [nzPlaceHolder]="'Recommended Outcome'" id="recommendedOutcome" formControlName="recommendedOutcome" (ngModelChange)="recommendedOutcomeChange($event)"
          id="recommendedOutcome" [nzShowSearch]="true">
            <nz-option *ngFor="let i of recommendedOutcomeList" [nzLabel]="i.label" [nzValue]="i.label"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24" *ngIf="appRemarks">
      <nz-form-item>
        <nz-form-label nzFor="approvalRemarks" nzRequired>Approval Remarks
          <span nz-tooltip nzTitle="Approval Remarks">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>
        <nz-form-control [nzErrorTip]="'Approval Remarks is Required'">
          <textarea required rows="2"  formControlName="approvalRemarks" nz-input id="approvalRemarks"></textarea>
        </nz-form-control>
        <small *ngIf="RISKASSApprovalForm.controls.approvalRemarks.value" class="form-text text-muted">
          <code>{{RISKASSApprovalForm.controls.approvalRemarks.value.length}}</code> of
          <code>{{RemarksMaxLength}}</code> characters</small>
      </nz-form-item>
    </div>
    <div nz-col [nzSpan]="12" *ngIf="onHold">
      <nz-form-item>
        <nz-form-label nzFor="holdTill">On Hold Till
          <span nz-tooltip nzTitle="On Hold Till">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>
        <nz-form-control>
          <nz-date-picker (ngModelChange)="onChangeholdTill($event)" [(ngModel)]="onholdRange" [ngModelOptions]="{standalone: true}"></nz-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col [nzSpan]="12" *ngIf="useBy">
      <nz-form-item>
        <nz-form-label nzFor="useBy">Use By
          <span nz-tooltip nzTitle="Use By">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>

        <nz-form-control>
          <nz-date-picker (ngModelChange)="onChangeuseBy($event)" id="onbyRange" [(ngModel)]="onbyRange" [ngModelOptions]="{standalone: true}"></nz-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item>
        <nz-form-label nzFor="internalRemarks">Internal Remarks
          <span nz-tooltip nzTitle="Internal Remarks">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>
        <nz-form-control [nzErrorTip]="'Text should not be more than 50 characters'">
          <textarea required rows="2" formControlName="internalRemarks" nz-input id="internalRemarks"></textarea>
        </nz-form-control>
        <small *ngIf="RISKASSApprovalForm.controls.internalRemarks.value" class="form-text text-muted">
          <code>{{RISKASSApprovalForm.controls.internalRemarks.value.length}}</code> of
          <code>{{RemarksMaxLength}}</code> characters</small>
      </nz-form-item>
    </div>
  </div>
  <div nz-row>
     <div nz-col nzXl="24" nzLg="24"nzMd="24" nzSm="24" nzXs="24">
    <div class="float-right">
      <button nz-button id="onSubmit" (click)="onSubmit()">Submit</button>
    </div>
  </div>
  </div>
</form>
